<ng-container [ngSwitch]="variant">
  <c11n-card *ngSwitchCase="'home'" [hasImage]="true" class="hero-card">
    <img class="header-image" cardImage [src]="config.imageSrc" [alt]="config.imageAltKey | translate" />

    <h2 cardHeading class="heading-with-chip">
      {{ config.headingKey | translate }}
      <span *ngIf="config.chipLabelKey" class="heading-chip"><c11n-chip [labelText]="config.chipLabelKey | translate"
          [color]="config.chipColor || 'yellow'"></c11n-chip></span>
    </h2>

    <div cardBody>
      <p class="mb-4">{{ config.bodyKey | translate }}</p>
      <ul class="check-list list-unstyled">
        <li *ngFor="let itemKey of config.checkItemKeys || []" class="d-flex align-items-start mb-3">
          <c11n-icon [name]="'success-fill'" [altText]="''" class="pe-1"></c11n-icon>
          <span>{{ itemKey | translate }}</span>
        </li>
      </ul>
    </div>

    <div cardAction class="card-actions">
      <c11n-button [labelText]="config.buttonLabelKey | translate" variant="secondary" targetWindow="_blank"
        [fullWidth]="true" [href]="(config.buttonHref | translate) || null"></c11n-button>
      <p class="text-center pt-2">
        <a c11n-link [routerLink]="config.linkRoute | langLink" class="c11n-text-md-bold">{{
          config.linkTextKey | translate
          }}</a>
      </p>
    </div>
  </c11n-card>

  <article *ngSwitchCase="'nic-option-1'" class="nic-option-card" [attr.aria-label]="ariaLabel || null">
    <div class="nic-option-card__content">
      <div class="nic-option-card__top-row">
        <span class="nic-option-card__chip">{{ config.chipLabelKey | translate }}</span>
        <img class="nic-option-card__icon" [src]="config.imageSrc" [alt]="config.imageAltKey | translate" />
      </div>

      <h3 class="nic-option-card__title">{{ config.headingKey | translate }}</h3>

      <p class="nic-option-card__body" *ngFor="let lineKey of config.descriptionLineKeys || []">{{ lineKey | translate
        }}</p>

      <h4 class="nic-option-card__subheading">{{ config.subheadingKey | translate }}</h4>

      <ul class="nic-resource-list" aria-label="Teacher resources">
        <li class="nic-resource-list__item" *ngFor="let item of config.resourceItems || []">
          <a c11n-link class="nic-resource-link c11n-text-sm" [href]="item.href | translate" [iconName]="'download'"
            [iconPosition]="'trailing'" [fontWeight]="'bold'" target="_blank" rel="noopener noreferrer">{{ item.labelKey
            | translate }}</a>
        </li>
      </ul>
    </div>
  </article>

  <article *ngSwitchCase="'nic-option-2'" class="nic-option-card" [attr.aria-label]="ariaLabel || null">
    <div class="nic-option-card__content">
      <div class="nic-option-card__top-row">
        <span class="nic-option-card__chip">{{ config.chipLabelKey | translate }}</span>
        <span class="nic-option-card__icon nic-option-card__icon--vanguard" aria-hidden="true">
          <img class="nic-option-card__vanguard-mark" [src]="config.imageSrc" [alt]="config.imageAltKey | translate" />
        </span>
      </div>

      <h3 class="nic-option-card__title">{{ config.headingKey | translate }}</h3>

      <p class="nic-option-card__body" *ngFor="let lineKey of config.descriptionLineKeys || []">{{ lineKey | translate
        }}</p>

      <p class="nic-option-card__body">
        {{ config.lessonLibraryPrefixKey | translate }}
        <a c11n-link [routerLink]="config.lessonLibraryRoute | langLink" [variant]="'secondary-reinforced'"
          [fontWeight]="'bold'">{{
          config.lessonLibraryLinkKey | translate
          }}</a>
        {{ config.lessonLibrarySuffixKey | translate }}
      </p>

      <div class="nic-option-card__subheading-row">
        <h4 class="nic-option-card__subheading nic-option-card__subheading--plain">{{ config.subheadingKey | translate
          }}</h4>
        <span class="nic-option-card__subheading-meta">
          <ng-container *ngIf="(config.sessionItems?.length || 0) === 1; else multipleSessions">{{
            'nic.cards.option2.sessionsAvailableOne' | translate: { count: config.sessionItems?.length || 0 }
            }}</ng-container>
          <ng-template #multipleSessions>{{
            'nic.cards.option2.sessionsAvailableOther' | translate: { count: config.sessionItems?.length || 0 }
            }}</ng-template>
        </span>
      </div>

      <ul class="nic-session-list" aria-label="Upcoming sessions">
        <li class="nic-session-list__item" *ngFor="let session of config.sessionItems || []">
          <div class="nic-session-list__timeblock">
            <span class="nic-session-list__date">{{ session.dateKey | translate }}</span>
            <span class="nic-session-list__time">{{ session.timeKey | translate }}</span>
          </div>
          <a c11n-link class="c11n-text-sm nic-session-list__link"
            [href]="session.hrefKey ? (session.hrefKey | translate) : (config.sessionButtonHref | translate)"
            [iconName]="'pop-window'" [iconPosition]="'trailing'" [fontWeight]="'bold'"
            [attr.aria-label]="'nic.cards.option2.sessionLinkAriaLabel' | translate: {
              label: (config.sessionButtonLabelKey | translate),
              date: ((session.ariaDateKey || session.dateKey) | translate),
              time: (session.timeKey | translate)
            }"
            target="_blank" rel="noopener noreferrer">{{
            config.sessionButtonLabelKey |
            translate }}</a>
        </li>
      </ul>

      <p class="nic-option-card__contact">
        <a c11n-link [routerLink]="config.contactRoute | langLink" [variant]="'secondary-reinforced'">{{
          config.contactLinkKey | translate
          }}</a>
        {{ config.contactSuffixKey | translate }}
      </p>

      <p class="nic-option-card__privacy" *ngIf="config.privacyLinkKey">
        {{ config.privacyPrefixKey | translate }}
        <a c11n-link [routerLink]="config.privacyRoute | langLink" [variant]="'secondary-reinforced'">{{
          config.privacyLinkKey | translate
          }}</a>
        {{ config.privacySuffixKey | translate }}
      </p>
    </div>
  </article>
</ng-container>